export default {
  'bad-request': 'リクエストされた内容をサーバーが理解できませんでした。',
  'auth-failed': '認証に失敗しました。',
  'not-access': '利用中のユーザーアカウントには、アクセス権限がありません。',
  'not-found': 'お探しのページが見つかりません。',
  'invalid-data': '無効なデータのため取得に失敗しました。',
  'get-failed': 'データの取得に失敗しました。',
  'server-error': 'サーバーエラーが発生しました。再度時間をおいてアクセスしてください。',
}
